import { applyMiddleware, createStore, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { createBrowserHistory as createHistory } from 'history';
import reducer from './reducers';

const appConfig = window.datashop.app.config();
const appBase = appConfig.siteprefix || '';
const moduleName = require('../../datashop.json').name;
const middleware = [thunk];

export const history = createHistory({ basename: `${appBase !== '/' ? appBase : ''}/${moduleName}` });

export const isCurrentAppUrl = () => {
  const url = window.location.pathname || moduleName;
  return url.includes(moduleName);
};

export const currentPath = () => {
  const url = window.location.pathname.split(moduleName)[1] || moduleName;
  return url;
};

if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger());
}

const middlewareEnhancer = applyMiddleware(...middleware);
const composedEnhancers = function () {
  return process.env.NODE_ENV !== 'production' ? composeWithDevTools(middlewareEnhancer) : compose(middlewareEnhancer);
};

export const store = createStore(reducer, composedEnhancers());
